/* eslint-disable no-unused-vars */
import React from "react";
import { Autoplay, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import GLightbox from 'glightbox';

import images from '../../assets/gallery.json';

import 'glightbox/dist/css/glightbox.min.css';


export default class ScreenshotSlider extends React.Component {

    breakpoints = {
        320: {
            slidesPerView: 1,
            spaceBetween: 30,
        },
        640: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
        992: {
            slidesPerView: 5,
            spaceBetween: 30,
        },
        1200: {
            slidesPerView: 7,
            spaceBetween: 30,
        },
    };
    autoplay = {
        delay: 5000,
        disableOnInteraction: false,
    };
    pagination = {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
    }
    componentDidMount() {
        /**
         * Initiate gallery lightbox
         */
        const galleryLightbox = GLightbox({
            selector: ".gallery-lightbox",
        });
    }

    render() {

        return (
            <div>
                <div className="container">
                    <div className="section-title">
                        <h2>Gallery</h2>
                    </div>
                </div>

                <div className="container-fluid">
                    <Swiper
                        modules={[Pagination, Autoplay]}
                        speed={400}
                        loop={true}
                        centeredSlides={true}
                        autoplay={this.autoplay}
                        slidesPerView={"auto"}
                        pagination={this.pagination}
                        breakpoints={this.breakpoints}
                    >
                        {images.map((im, i) => {
                            return (
                                <SwiperSlide key={i}>
                                    <a href={`${im}`} className="gallery-lightbox" data-gall="gallery-carousel" data-zoomable="true">
                                        <img width="300" height="560" src={`${im}`} className="img-fluid" alt="Screenshots" />
                                    </a>
                                </SwiperSlide>
                            )
                        })}
                        <div className="swiper-pagination"></div>
                    </Swiper>
                </div>
            </div >
        );
    }
}
